import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router';
import ROUTES from 'src/lib/routes';
import useRouter from 'src/hooks/useRouter';
import NavTop from 'src/components/nav-top';
import ScreenWidth from 'src/components/screen-width';
import SearchForProduct from 'src/components/search-for-product-home';
import COLORS from 'src/lib/colors';
import { CommonPageProps } from 'src/screens/product-browse/common-page';
import RecentlySearched from 'src/components/recently-searched';
import RecentlyViewedItems from 'src/components/recently-viewed-items';
import useStoreData from 'src/hooks/useStoreData';
import AutoCompeleteList from 'src/components/AutoCompeleteList';
import { setPreviousPath } from 'src/lib/utils/setPreviousPath';
import { useProductBrowseContext } from 'src/lib/contexts/product-browse-context';
import {
    footerHeight,
    storeModeStickyHeight,
    thinHeaderHeight,
} from 'src/lib/constants';
import { useShipmentTracking } from 'src/lib/contexts/ShipmentTrackingContext';

const useStyles = makeStyles({
    form: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        gap: '15px',
    },
    searchWrapper: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },
    cancelBtn: {
        color: COLORS.primaryWhite,
        fontWeight: 400,
        fontSize: '0.875rem',
        display: 'flex',
        flexShrink: 1,
        padding: 0,
        minWidth: 47,
    },
    navContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '17px 18px',
        height: '70px',
    },
    navSubContainer: {
        overflow: 'auto',
    },
});

const FIVE_MINUTES = 300000;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ProductSearchLandingScreen(props: CommonPageProps) {
    const classes = useStyles();
    const { mainStore, isStoreModeOn } = useStoreData();
    const { goBackRoute, setGoBackRoute } = useShipmentTracking();

    const { push, location, pathname } = useRouter();
    const { fromPath, setFromPath, goBack, end } = useProductBrowseContext();

    function handleSubmit(searchString: string) {
        const path =
            ROUTES.productDetailsPage === location.pathname
                ? fromPath
                : location.pathname;
        setFromPath(path);
        if (pathname && !pathname.includes(ROUTES.lists)) {
            end();
            push(
                `${ROUTES.productDetailsPage}?searchString=${searchString}`,
                setPreviousPath(location, path)
            );
        }
    }
    function onClickCancel() {
        if (goBackRoute && goBackRoute === 'WALLETINFDRAWER') {
            setGoBackRoute(undefined);
            push(ROUTES.rewardsWallet);
            end();
        } else if (pathname && pathname.includes(ROUTES.lists)) {
            goBack();
        } else {
            push(fromPath);
            end();
        }
    }

    const isFromLists = location?.pathname.includes('/lists');

    return (
        <ScreenWidth>
            <NavTop
                noBorderRadius
                bgColor={COLORS.brandRed}
                bgImageSrc={require('../../../assets/bgs/header-bg.svg')}
                minHeight="70px"
                className={classes.navContainer}
            >
                <div className={classes.form}>
                    <div className={classes.searchWrapper}>
                        <SearchForProduct
                            handleSubmit={handleSubmit}
                            mainStore={mainStore}
                            autoFocus
                        />
                    </div>
                    <Button
                        className={classes.cancelBtn}
                        onClick={onClickCancel}
                        aria-label="Cancel button"
                        aria-selected="true"
                        aria-roledescription="Go back to previous page"
                    >
                        Cancel
                    </Button>
                </div>
            </NavTop>
            <div
                className={classes.navSubContainer}
                style={{
                    height: isStoreModeOn
                        ? `calc(100vh - ${thinHeaderHeight} - ${storeModeStickyHeight} - ${footerHeight})`
                        : `calc(100vh - ${thinHeaderHeight} - ${footerHeight})`,
                }}
            >
                <AutoCompeleteList />
                {isFromLists ? null : (
                    <>
                        <RecentlyViewedItems />
                        <RecentlySearched />
                    </>
                )}
            </div>
        </ScreenWidth>
    );
}

export default React.memo(ProductSearchLandingScreen, () => true);
